module.exports = __webpack_public_path__ + "img/list.fe412547.svg";